import Image from "next/image";
import React, { useState, useEffect } from "react";
import { MdOutlineNavigateNext } from "react-icons/md";
import SocialShare from "components/social/SocialShare";
import YouTubePlayer from "components/youtube/YouTubePlayer";

const CardMobile = ({ item, showOpen = false, onClick = () => {} }) => {
  const [showPoster, setShowPoster] = useState(!item?.videoUrl);
  const [playerState, setPlayerState] = useState(0);
  const [firstView, setFirstView] = useState("text");

  useEffect(() => {
    if (playerState === 0 || playerState === 2) {
      setFirstView("text");
    }
    if (playerState === 1) {
      setFirstView("video");
    }
  }, [playerState]);

  return (
    <div className="relative w-full flex items-center justify-between">
      {/* Video Container */}
      <div
        onClick={() => setFirstView("video")}
        className={`rounded-2xl overflow-hidden aspect-video w-full md:w-[600px] lg:w-[1000px] ${firstView === "video" ? "z-50" : "z-10"}`}
      >
        {showPoster && item?.poster ? (
          <div
            onClick={() => item?.videoUrl && setShowPoster(false)}
            className="relative w-full h-full"
          >
            <Image
              width={0}
              height={0}
              sizes="100vh"
              className="object-cover h-full w-full"
              src={item?.poster}
              alt="poster"
              layout="responsive"
              priority
            />
            <div className="absolute top-0 left-0 h-full w-full bg-black bg-opacity-40 flex items-center justify-center rounded-2xl" />
          </div>
        ) : (
          <YouTubePlayer
            videoUrl={item?.videoUrl}
            onPlayerStateChange={setPlayerState}
          />
        )}
      </div>
      {/* Text Container */}
      <div
        onClick={() => setFirstView("text")}
        className={`h-72 absolute top-44 w-full md:w-1/2 bg-white bg-opacity-90 p-6 rounded-2xl shadow-2xl flex flex-col justify-center ${
          firstView === "text" ? "z-50" : "z-10"
        }`}
      >
        {showOpen ? (
          <p
            onClick={onClick}
            className={`text-xl font-semibold text-gray-900 mb-4 line-clamp-2 hover:cursor-pointer hover:underline`}
          >
            {item?.title || "Default Title"}
          </p>
        ) : (
          <p
            className={`text-xl font-semibold text-gray-900 mb-4 line-clamp-2`}
          >
            {item?.title || "Default Title"}
          </p>
        )}
        <p className="text-gray-700 leading-relaxed line-clamp-5">
          {item?.description ||
            "Default description text to fill in placeholder space."}
        </p>
        {showOpen ? (
          <div
            onClick={onClick}
            className="ml-auto mt-auto hover:cursor-pointer"
          >
            <MdOutlineNavigateNext color={"#6E6E6E"} size={40} />
          </div>
        ) : (
          <SocialShare />
        )}
      </div>
    </div>
  );
};

export default CardMobile;
